import produce from 'immer';
import * as actions from '../actions/actionTypes';

const calendar = (state = initCalendarStore(), action) =>
    produce(state, draft => {
        switch (action.type) {
            case actions.CALENDAR_MOBILE_SET_TEST_INFO:
                draft.mobileTestInfo = {
                    yearCount: action.yearCount,
                    year: action.year,
                    monthIndx: action.monthIndx,
                    iconName: action.iconName,
                };
                break;
            default:
                break;
        }
    });

export const initCalendarStore = () => {
    return {
        mobileTestInfo: {
            yearCount: '',
            year: '',
            monthIndx: '',
            iconName: '',
        },
    };
};

export default calendar;
